import { useState } from 'react'

export const useAccordionsLogic = () => {
  const [expandedRosterIds, setExpandedRosterIds] = useState<number[]>([])

  const handleExpandRosterToggle = (id: number) => {
    setExpandedRosterIds(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id],
    )
  }

  return {
    expandedRosterIds,
    handleExpandRosterToggle,
  }
}
